import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=7c599b1c&"
import script from "./choice.vue?vue&type=script&lang=js&"
export * from "./choice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports